// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__ed0c743c07fb50d07104","cls2":"ResearchInterestTags-cls2___f9084eb3ada7bba2f1c ResearchInterestTags-cls1__ed0c743c07fb50d07104"};